import AlRsvpCheckinsComponentController from './controller';
import templateUrl from './component.tpl.html';

angular
    .module('festzelt-os.contacts')
    .component('alRsvpCheckins', {
        bindings: {
            rsvp: '<'
        },
        controller: AlRsvpCheckinsComponentController,
        controllerAs: 'vm',
        templateUrl: templateUrl
    });



// WEBPACK FOOTER //
// ./src/app/modules/rsvps/components/al-rsvp-checkins/component.js